module.exports = __webpack_public_path__ + "static/boy-c9adf9e6200f58bdd29cbdd4d97bd306.svg";